<template>
	<AppDialog :disableMaxWidth="true" dialogName="DeleteWorkspaceDialog" :height="heightPX" :width="widthPX">
		<Col :style="{ minHeight: heightPX, width: widthPX }" class="content-container flex-align-center flex-justify-space-between">
			<Col class="flex-align-center">
				<h2 class="bold mb-3">{{ title }}</h2>
				<component
					v-if="titleSuffixComponent?.component"
					:class="titleSuffixComponent.class"
					v-bind="titleSuffixComponent.props"
					:is="titleSuffixComponent.component"
				/>
				<Row class="danger-area pa-2 width-100"> {{ dangerText }} </Row>
				<Col class="width-100">
					<h3 v-html="areYouSureText" class="reg display-flex flex-row my-5" />
					<h5 class="input-description">{{ verificationDescription }}</h5>
					<AppTextField class="mt-2" v-if="confirmationText" v-model="confirmationInput" :placeholder="confirmationPlaceholder" outlined />
				</Col>
			</Col>
			<Col>
				<AppTooltip position="top" :text="verificationDescription" :disabled="!blockYes">
					<AnemicButton :loading="isLoading" @click="yes" :disabled="blockYes || isLoading" class="pa-0 delete-button" tile>
						{{ yesButtonText }}
					</AnemicButton>
				</AppTooltip>
				<AnemicButton @click="no" class="px-1 cancel-button" tile>{{ noButtonText }}</AnemicButton>
			</Col>
		</Col>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service.js';
import { APP_CONFIRMATION_DIALOG_RESPONSES } from '@/components/dialogs/AppDialogs/app-confirmation-dialog.const.js';
export default {
	name: 'DeleteWorkspaceDialog',
	components: { AppDialog },
	props: {
		title: { type: String },
		dangerText: { type: String },
		verificationDescription: { type: String },
		yesButtonText: { type: String, default: 'Yes' },
		noButtonText: { type: String, default: 'Cancel' },
		areYouSureText: { type: String, default: 'Are you sure you want to delete this?' },
		titleSuffixComponent: { type: Object, default: () => ({ component: null, props: {} }) },
		onYes: { type: Function }, // for loading state
		dialogPromiseHandlers: { type: Object },
		confirmationText: { type: String, required: true },
		height: { type: [String, Number], default: '590' },
		width: { type: [String, Number], default: '500' },
	},
	computed: {
		blockYes() {
			return this.confirmationText && this.confirmationInput.replaceAll(`"`, '') !== this.confirmationText;
		},
		confirmationPlaceholder() {
			return `Type "${this.confirmationText}" to confirm`;
		},
		heightPX() {
			return `${this.height}px`;
		},
		widthPX() {
			return `${this.width}px`;
		},
	},
	methods: {
		async yes() {
			if (this.blockYes) {
				return;
			}
			if (this.onYes) {
				this.isLoading = true;
				await this.onYes();
				this.isLoading = false;
			}
			this.dialogPromiseHandlers.resolve(APP_CONFIRMATION_DIALOG_RESPONSES.YES);
			AppDialogManagerService.closeCurrentDialog();
		},
		no() {
			this.dialogPromiseHandlers.resolve(APP_CONFIRMATION_DIALOG_RESPONSES.NO);
			AppDialogManagerService.closeCurrentDialog();
		},
	},

	data() {
		return {
			isLoading: false,
			confirmationInput: '',
		};
	},
};
</script>

<style scoped lang="scss">
.content-container {
	overflow: hidden;
	border-radius: 10px;
	background: var(--white);
	padding: 40px 40px 20px 40px;
}
.footer-button {
	height: 40px !important;
	font-size: 14px !important;
	min-width: 182px !important;
	border-radius: 8px !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	text-transform: none !important;
}

.delete-button {
	@extend .footer-button;
	color: var(--white) !important;
	background: #e84e53 !important;
	&.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
		color: rgb(255, 255, 255, 0.7) !important;
		background-color: rgb(250, 215, 219) !important;
	}
}

.cancel-button {
	@extend .footer-button;
	margin-top: 6px;
	border: 1px solid #d6ddea;
	background: var(--white) !important;
	color: var(--primary-font-color) !important;
}
.danger-area {
	font-size: 14px;
	border-radius: 5px;
	background: #fad7db;
	border: 1px solid #e2e7f0;
	color: var(--primary-font-color);
}
.input-description {
	opacity: 0.5;
	color: #444444;
}
</style>
